var r,e;function n(){return e?r:(e=1,r=function(r,e){return{value:r,done:e}})}export{n as __require};
//# sourceMappingURL=create-iter-result-object.js.map
